import PropTypes from 'prop-types';
import React from 'react';

import { MultiSwitch } from '../../../../../atomic/buttons/multiSwitch/MultiSwitch';

export const AuxPanelSwitch = ({ selection, setSelection }) => {
  return (
    <div style={{ marginBottom: '5px' }}>
      <MultiSwitch
        justifyContent="center"
        labels={['Bid/Ask', 'Time+Sales']}
        values={['bidAsk', 'timeSale']}
        controlledValue={selection}
        setValue={setSelection}
      />
    </div>
  );
};

AuxPanelSwitch.propTypes = {
  selection: PropTypes.string,
  setSelection: PropTypes.func,
};
